// import * as CONST from '../util/app-constants';

const initalState = {
    username: 'James Anderson',
    password: null,
    signedIn: null,
    data: null,
    userAttributes: null,
    isAdmin: null,
    themeToApply: null,
    cognitoUser: null,
    smsNotification: null
};

const profileInfo = (state = initalState, action) => {
    if (action.type === 'SIGN_IN') {
        return {
            ...state,
            username: action.payload.username,
            password: action.payload.password,
            signedIn: true,
            data: action.loginData,
        };
    }

    if (action.type === 'SIGN_OUT') {
        return {
            ...initalState
        };
    }

    if (action.type === 'UPDATE_USERNAME') {
        return {
            ...state,
            username: action.username,
        };
    }
    if (action.type === 'COGNITO_USER_SET') {
        return {
            ...state,
            userData: action.userData,
        };
    }

    if (action.type === 'UPDATE_EMAIL_VERIFY_FIELD') {
        return {
            ...state,
            data: action.payload,
        };
    }

    if (action.type === 'FETCHED_USER_ATTRIBUTES') {
        const attributeList = {};
        let name;
        let value;
        let isSMSEnabled;
        for (let i = 0; i < action.payload.length; i += 1) {
            name = action.payload[i].Name;
            value = action.payload[i].Value;
            attributeList[name] = value;
        }
        isSMSEnabled = attributeList['custom:smsNotification'];

        // console.log('Attribute List', attributeList);

        return {
            ...state,
            userAttributes: attributeList,
            smsNotification: isSMSEnabled
        };
    }

    if (action.type === 'PROFILE_DETAILS_UPDATE') {
        return {
            ...state,
            userAttributes: action.payload,
        };
    }

    if (action.type === 'IS_ADMIN?') {
        return {
            ...state,
            isAdmin: action.payload,
        };
    }

    if (action.type === 'CHANGE_THEME_IN_STORE') {
        return {
            ...state,
            themeToApply: action.color,
        };
    }
    if (action.type === 'UPDATE_SMS_NOTIFICATION') {
        return {
            ...state,
            smsNotification: action.isSMSNotificationChecked,
        };
    }

    return state;
};

export default profileInfo;



// WEBPACK FOOTER //
// ./reducers/ProfileInfo.js